// A hundred chart, or whole rows of one. Plain React SVG, like
// practice-count.tsx. A shaded square is filled AND carries a dot in its
// corner (like practice-shade-grid.tsx), so it is told apart without colour.
// A hidden number shows "?" on a dashed square.

import {
  describeHundredChart,
  hundredChartPicture,
  type HundredChartSpec,
} from './practice-hundred-chart-data';

const INK = '#2d4a3e';
const SHADE_FILL = '#9fc5b3';
const HIDDEN_FILL = '#fff6d6';

export function HundredChartView({ chart }: { chart: HundredChartSpec }) {
  const picture = hundredChartPicture(chart);
  const { cell } = picture;
  return (
    <figure className="m-0 max-w-md">
      <svg
        role="img"
        aria-label={describeHundredChart(chart)}
        viewBox={`0 0 ${String(picture.width)} ${String(picture.height)}`}
        className="mx-auto block h-auto w-full"
        style={{ maxWidth: `${String(Math.round(picture.width * 1.3))}px` }}
      >
        {picture.cells.map((square) => (
          <g
            key={square.value}
            data-cell={square.hidden ? 'hidden' : square.value}
            data-shaded={square.shaded ? 'true' : undefined}
          >
            <rect
              x={square.x}
              y={square.y}
              width={cell}
              height={cell}
              fill={
                square.shaded
                  ? SHADE_FILL
                  : square.hidden
                    ? HIDDEN_FILL
                    : '#ffffff'
              }
              stroke={INK}
              strokeWidth="1"
            />
            {square.hidden && (
              <rect
                x={square.x + 3}
                y={square.y + 3}
                width={cell - 6}
                height={cell - 6}
                fill="none"
                stroke={INK}
                strokeWidth="1.2"
                strokeDasharray="3 2"
              />
            )}
            {square.shaded && (
              <circle
                data-dot="true"
                cx={square.x + cell - 6}
                cy={square.y + 6}
                r="3"
                fill={INK}
              />
            )}
            <text
              x={square.x + cell / 2}
              y={square.y + cell / 2}
              dy="0.35em"
              textAnchor="middle"
              fill={INK}
              fontSize={square.hidden ? 17 : 13}
              fontWeight={square.hidden ? '700' : '500'}
            >
              {square.hidden ? '?' : square.value}
            </text>
          </g>
        ))}
      </svg>
    </figure>
  );
}
